
import { Component, Vue } from 'vue-property-decorator';
import CloudMallMode from '@/views/components/appVisitList';
import MirrorMallMode from '@/views/components/appVisitList/mirrorMallMode';

@Component({
  components: {
    CloudMallMode,
    MirrorMallMode,
  },
})
export default class AppSumUpBoard extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  isContentBodyShow = 0

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    localStorage.setItem('curpage', key);
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 获取当前页索引
    // 权限检测
    this.isContentBodyShow = +localStorage.getItem('isOpenVisitTrend');
    if (this.isContentBodyShow) {
      this.curPage = localStorage.getItem('curpage') ? localStorage.getItem('curpage') : this.$route.query.index ? this.$route.query.index.toString() : '1';
    }

  }

}
